import styled from '@emotion/styled';

import { customPalette } from '../../../../styles/theme';

export const Banner = styled.div<{ $color: string }>`
  position: relative; 
  display: flex;
  min-height: 72px;
  padding: 16px;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
  align-self: stretch;  
  cursor: pointer;
  justify-content: space-between;
  border-radius: 8px;
  background-color: ${(props) => props.$color || customPalette.accent.main}};
  color: ${customPalette.accent.white};
  height: 100%;
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  border-bottom: 1px solid ${customPalette.accent.white};
`;

export const Headline = styled.div`
  color: var(--Neutral-Dark-Blue, #00223c);

  font-family: Nunito;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 21.6px;
  letter-spacing: 0.15px;
  word-break: break-word;
`;

export const SubHeadline = styled.div`
  color: var(--Neutral-Dark-Blue, #00223c);

  font-family: Nunito;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%; /* 12px */
  letter-spacing: 0.2px;
`;

export const MenuButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  position: absolute;
  top: 2px;
  right: 2px;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: 40px;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
  width: 100px;
  z-index: 10;
`;

export const MenuItem = styled.button`
  display: block;
  width: 100%;
  padding: 8px;
  text-align: left;
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background-color: #f3f3f3;
  }

  &.delete {
    color: red;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HeadlineAndSubheadlineContainer = styled.div`
  flex-grow: 1;
  max-width: 137px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
export const LinkButtonContainer = styled.div``;

export const BannerImage = styled.img`
  width: 100%;
  height: 47px;
  display: block;
  object-fit: cover;
`;

export const LinkButton = styled.div`
  border-radius: var(--Border-Radius-L, 18px);
  opacity: 0.8;
  background: var(--Primary-Mittelblau, #007ec3);
  display: flex;
  width: 32px;
  height: 32px;
  padding: 6px;
  justify-content: space-between;
  align-items: center;
`;
